export type DeviceClass = 'phone' | 'tablet' | 'desktop';

const PHONE_UA = /iPhone|iPod|Windows Phone|IEMobile|BlackBerry|Opera Mini|Android.+Mobile/i;
const TABLET_UA = /iPad|Tablet|PlayBook|Silk|Android(?!.*Mobile)/i;

/**
 * Phone and tablet user agents win over window width, so a phone in landscape
 * still counts as a phone. A narrow desktop window counts as a phone layout.
 */
export function classifyDevice(
  width: number,
  userAgent: string,
  maxTouchPoints = 0
): DeviceClass | null {
  const ua = userAgent || '';
  if (PHONE_UA.test(ua)) return 'phone';
  if (TABLET_UA.test(ua)) return 'tablet';
  if (/Macintosh/i.test(ua) && maxTouchPoints > 1) return 'tablet';
  if (width > 0 && width < 768) return 'phone';
  if (width > 0 && width < 1024) return 'tablet';
  if (width >= 1024) return 'desktop';
  return null;
}

export function readClientDevice(): { device: DeviceClass; viewportWidth: number } {
  const width = typeof window !== 'undefined' ? window.innerWidth || 0 : 0;
  const ua = typeof navigator !== 'undefined' ? navigator.userAgent || '' : '';
  const touch =
    typeof navigator !== 'undefined' && typeof navigator.maxTouchPoints === 'number'
      ? navigator.maxTouchPoints
      : 0;
  return {
    device: classifyDevice(width, ua, touch) || 'desktop',
    viewportWidth: width,
  };
}
